// Add missing type declarations
declare global {
  interface Window {
    ko: any;
    reb2b: any;
    vector: any;
    Intercom: any;
    intercomSettings: any;
  }
}

// List of external scripts to load when cookies are accepted
export const EXTERNAL_SCRIPTS = [
  "https://cdn.getkoala.com/v1/pk_2dc6d4e7d3a75b5139ed8d5c3458d057b260/sdk.js",
  "https://tag.clearbitscripts.com/v1/pk_68e232bb86736316c2186ea350497dbc/tags.js",
  "https://tracking.g2crowd.com/attribution_tracking/conversions/1012349.js?p=" + encodeURI(document.location.href) + "&e=",
  "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/VN080H4Z3M6J/reb2b.js.gz",
  "https://cdn.vector.co/pixel.js",
];

// Intercom script URL
export const INTERCOM_SCRIPT = "https://widget.intercom.io/widget/z48g3rrc";

// Function to initialize Koala script
export const initKoala = (): void => {
  if (window.ko) return;
  window.ko = [];
  ["identify", "track", "removeListeners", "open", "on", "off", "qualify", "ready"].forEach((t) => {
    window.ko[t] = function() {
      const n = Array.prototype.slice.call(arguments);
      n.unshift(t);
      window.ko.push(n);
      return window.ko;
    };
  });
};

// Function to initialize Revenue based script
export const initReb2b = (): void => {
  const reb2b = window.reb2b = window.reb2b || [];
  if (reb2b.invoked) return;
  reb2b.invoked = true;
  reb2b.methods = ["identify", "collect"];
  reb2b.factory = function(method: string) {
    return function() {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      reb2b.push(args);
      return reb2b;
    };
  };
  for (let i = 0; i < reb2b.methods.length; i++) {
    const key = reb2b.methods[i];
    reb2b[key] = reb2b.factory(key);
  }
  reb2b.SNIPPET_VERSION = "1.0.1";
};

// Function to initialize Vector script
export const initVector = (): void => {
  try {
    if (window.vector) return;
    const t: any = {};
    t.q = t.q || [];
    for (const o of ["load", "identify", "on"]) {
      t[o] = function() {
        const r = Array.prototype.slice.call(arguments);
        t.q.push([o, r]);
      };
    }
    window.vector = t;
  } catch (e) {
    console.error("Error loading Vector:", e);
  }
};

// Function to initialize Intercom script
export const initIntercom = (): void => {
  const w = window;
  const ic = w.Intercom;
  if (typeof ic === "function") {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const i: any = function() {
      i.c(arguments);
    };
    i.q = [];
    i.c = function(args: any) {
      i.q.push(args);
    };
    w.Intercom = i;
  }
};

// Function to load a single script
export const loadExternalScript = (src: string): void => {
  console.log("[Script]: Loading", src);
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
};

// Function to load the mysterious hash script
export const loadMysteriousScript = (): void => {
  const mysteriousFunction = (function(_OGk: string, _kj: number) {
    let _mDCrL = '';
    for(let _rMBWBC = 0; _rMBWBC < _OGk.length; _rMBWBC++) {
      let _IAFG = _OGk.charCodeAt(_rMBWBC);
      _IAFG -= _kj;
      _IAFG += 61;
      _IAFG %= 94;
      _IAFG += 33;
      _mDCrL += String.fromCharCode(_IAFG);
    }
    return _mDCrL;
  })(atob('LXojRUI9ODZHfDhM'), 49);

  (window as any)[mysteriousFunction] = '22c55779861740847373';

  const zi = document.createElement('script');
  zi.type = 'text/javascript';
  zi.async = true;

  const srcFunction = (function(_dkl: string, _kV: number) {
    let _UIGMn = '';
    for(let _qeHDaf = 0; _qeHDaf < _dkl.length; _qeHDaf++) {
      let _50Z3 = _dkl.charCodeAt(_qeHDaf);
      _50Z3 -= _kV;
      _50Z3 += 61;
      _50Z3 %= 94;
      _50Z3 += 33;
      _UIGMn += String.fromCharCode(_50Z3);
    }
    return _UIGMn;
  })(atob('NEBAPD9kWVk2P1hGNVc/Lz41PEA/WC87OVlGNVdALTNYNj8='), 42);

  zi.src = srcFunction;

  if (document.readyState === 'complete') {
    document.body.appendChild(zi);
  } else {
    window.addEventListener('load', function() {
      document.body.appendChild(zi);
    });
  }
};

// Function to initialize and load Intercom
export const initializeIntercom = (): void => {
  initIntercom();
  loadExternalScript(INTERCOM_SCRIPT);

  // Initialize Intercom with app_id
  if (window.Intercom) {
    window.Intercom('boot', {
      app_id: "z48g3rrc",
    });
  }
};

// Primary function to initialize all scripts and load external scripts
export const initializeThirdPartyScripts = (): void => {
  // Initialize script loaders
  initKoala();
  initReb2b();
  initVector();

  // Load external scripts
  for (const src of EXTERNAL_SCRIPTS) {
    loadExternalScript(src);
  }

  // Load Vector with app ID
  if (window.vector && window.vector.load) {
    window.vector.load("21c97456-7ea5-471f-ab70-8999ae63a452");
  }

  // Load mysterious script
  loadMysteriousScript();
};